
<div *ngIf="!isLiberado()" class="dss-loading">
  <div class="loader"></div>
</div>

<div *ngIf="isLiberado()" [ngClass]="{'wrapper-light' : isDssLayout() && !isThemeDark(), 'wrapper-dark' : isDssLayout() && isThemeDark()}">
  <div>
    <div id="main-content" class="main-content">
      <div class="content-wrapper">
        <div class="container-fluid">

          <router-outlet></router-outlet>

        </div>
      </div>
    </div>
  </div>
</div>
